import type {
  HeadlineResponse,
  HeadlineResponsePagedData,
  SiteCategoryResponse,
} from '@on3/api';
import type { IGenericPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import { Link } from '@on3/ui-lib/components/Link';
import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { ArticleFeedArticle } from 'components/Headlines/ArticleFeed/ArticleFeed';
import { RightSidebarLayout } from 'components/Layouts/RightSidebarLayout';
import { StandardSidebar } from 'components/Layouts/StandardSidebar';
import {
  AboutBlockMenu,
  InternalBlockMenu,
} from 'components/Menu/InternalBlockMenu';
import { InternalMenu, NilInternalMenu } from 'components/Menu/InternalMenu';
import { Pagination } from 'components/UI/Pagination/Pagination';
import { useRouter } from 'next/router';
import { useCallback, useState } from 'react';

import styles from './CategoryPage.module.scss';

export interface ICategoryProps {
  articles?: HeadlineResponsePagedData | null;
  category: SiteCategoryResponse;
  pageTitle?: string;
}

export interface ICategoryPageProps extends ICategoryProps, IGenericPageProps {}

export const CategoryPage = ({
  articles,
  category,
  pageTitle,
}: ICategoryProps) => {
  const { list, pagination } = articles || {};
  const { currentSite } = useSite();
  const [pageNumber, setPageNumber] = useState(pagination?.currentPage);
  const router = useRouter();
  const { categoryName } = category || {};
  const showSubMenu = currentSite?.name === 'NIL';
  const isPressFeed = router.asPath === '/category/press/news/';
  const isSportsBetting = category.categoryKey === 548333;

  const handleChange = useCallback(
    (event: React.ChangeEvent<unknown>, value: number) => {
      setPageNumber(value);
      router.push({
        pathname: router.pathname,
        query: { ...router.query, page: value },
      });
    },
    [router],
  );

  return (
    <RightSidebarLayout>
      <section className={styles.container}>
        <header className={styles.header}>
          <h1>
            {pageTitle
              ? pageTitle
              : `${categoryName}${
                  !categoryName?.includes('News') ? ' News' : ''
                }`}
          </h1>
          {isSportsBetting && (
            <Link className={styles.promotional} href="https://www.betmgm.com/">
              <span>By</span>
              <img
                alt="BETMGM Logo"
                src="https://on3static.com/static/on3/mgm-branding.svg"
              />
            </Link>
          )}
        </header>
        {showSubMenu && <InternalMenu list={NilInternalMenu} />}
        {isPressFeed && <InternalBlockMenu list={AboutBlockMenu} />}
        <Pagination
          count={pagination?.pageCount}
          onChange={handleChange}
          page={pageNumber}
        />

        {list && list?.length > 0 ? (
          list?.map((item: HeadlineResponse) => {
            if (!item?.key) {
              return null;
            }

            return <ArticleFeedArticle {...item} key={item?.key} />;
          })
        ) : (
          <div className={styles.noarticles}>
            <p>There are no articles for {categoryName}.</p>
          </div>
        )}
        <Pagination
          count={pagination?.pageCount}
          onChange={handleChange}
          page={pageNumber}
        />
      </section>
      <StandardSidebar />
    </RightSidebarLayout>
  );
};
